const DEFAULT_FONT_SIZE = "1rem";
const DEFAULT_ITEM_SPACING = 12;
const placeholderStyle = {
  color: "rgba(22, 45, 61, 0.64)",
  fontStyle: "italic",
  lineHeight: 1.5
};
const listDepthStyle = (depth) => ({
  listStyle: "none",
  margin: 0,
  padding: 0,
  paddingLeft: depth > 0 ? 20 : 0
});
const linkStyle = {
  alignItems: "baseline",
  cursor: "pointer",
  display: "inline-flex",
  gap: 8,
  lineHeight: 1.45
};
const markerStyle = {
  display: "inline-block",
  flexShrink: 0,
  fontVariantNumeric: "tabular-nums",
  minWidth: 20
};
const alphabeticalIndexNavListStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px 16px",
  listStyle: "none",
  marginBottom: 24,
  marginTop: 0,
  padding: 0
};
const alphabeticalIndexSectionStyle = {
  marginTop: 24
};
const alphabeticalIndexEntryListStyle = {
  listStyle: "none",
  margin: 0,
  padding: 0
};
const toCssLength = (value) => {
  if (value === void 0) {
    return void 0;
  }
  return typeof value === "number" ? `${value}px` : value;
};
const toHalfCssLength = (value) => {
  if (value === void 0) {
    return void 0;
  }
  return typeof value === "number" ? `${value / 2}px` : `calc(${value} / 2)`;
};
const addPxToCssLength = (value, addition) => {
  if (value === void 0) {
    return void 0;
  }
  return typeof value === "number" ? `${value + addition}px` : `calc(${value} + ${addition}px)`;
};
const resolveViewStyles = ({
  data,
  theme
}) => {
  const themeStyles = theme.customStyles?.toc;
  const color = data.color ?? themeStyles?.color ?? theme.customStyles?.link?.color;
  const fontSize = toCssLength(data.fontSize ?? themeStyles?.fontSize ?? DEFAULT_FONT_SIZE);
  const itemSpacing = data.itemSpacing ?? themeStyles?.itemSpacing ?? DEFAULT_ITEM_SPACING;
  const titleColor = themeStyles?.titleColor ?? theme.customStyles?.p?.color ?? (theme.palette && typeof theme.palette === "object" && "textColor" in theme.palette ? theme.palette.textColor : void 0) ?? "#162D3D";
  const sectionBorderColor = themeStyles?.borderColor ?? "rgba(22, 45, 61, 0.24)";
  return {
    containerStyle: {
      paddingBlock: "8px",
      paddingInline: "0px"
    },
    linkStyle: {
      ...linkStyle,
      fontSize,
      ...color ? { color } : {}
    },
    listItemStyle: {
      margin: `${toHalfCssLength(itemSpacing)} 0`
    },
    alphabeticalIndexLetterStyle: {
      fontSize: "2rem",
      fontWeight: 600,
      lineHeight: 1.1,
      margin: 0,
      color: titleColor
    },
    alphabeticalIndexGroupLinkStyle: {
      ...linkStyle,
      fontSize,
      fontWeight: 500,
      marginRight: 8,
      ...color ? { color } : {}
    },
    alphabeticalIndexEntryLinkStyle: {
      ...linkStyle,
      fontSize,
      fontWeight: 600,
      marginBottom: 4,
      ...color ? { color } : {}
    },
    alphabeticalIndexEntryStyle: {
      marginTop: addPxToCssLength(itemSpacing, 4)
    },
    alphabeticalIndexDividerStyle: {
      borderTop: `1px solid ${sectionBorderColor}`,
      margin: "12px 0 20px"
    }
  };
};
export {
  alphabeticalIndexEntryListStyle,
  alphabeticalIndexNavListStyle,
  alphabeticalIndexSectionStyle,
  linkStyle,
  listDepthStyle,
  markerStyle,
  placeholderStyle,
  resolveViewStyles
};
//# sourceMappingURL=resolve-styles.js.map
